
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ir/public-notice",
      function () {
        return require("private-next-pages/ir/public-notice/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ir/public-notice"])
      });
    }
  